import { ErrorMessage } from 'aa_common/front-end/antd'
import { LinkLabel } from 'aa_common/front-end/components'
import InputNumber from 'aa_common/front-end/components/form/form-input-number'
import { IMPAIRMENT_LOSS_APPLY_METHOD } from 'common/constants'
import { yenCheckNull } from 'common/helpers'
import { useNextEffect } from 'common/hooks/use-next-effect'
import { getNs } from 'common/i18n-config'
import { useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { AntInputAlignRight, SmallLabelClass } from '../styles'
import { FIELD_NAMES } from '../validation'

type ImpairmentLostProps = {
  impairmentAmountMaximum?: number
}

const { t, useNsReady } = getNs(['components/organisms/assets/asset-impairment'])

const FieldName = FIELD_NAMES.impaired_amount

export const ImpairmentLost = ({ impairmentAmountMaximum }: ImpairmentLostProps) => {
  useNsReady()
  const { setValue } = useFormContext()

  const impairmentMethod = useWatch<number>({
    name: FIELD_NAMES.impairment_method,
  })
  const canEdit = impairmentMethod === IMPAIRMENT_LOSS_APPLY_METHOD.END_OF_CURRENT_MONTH

  useNextEffect(() => {
    setValue(FIELD_NAMES.impaired_amount_maximum, impairmentAmountMaximum)
    setValue(FieldName, impairmentAmountMaximum)
  }, [impairmentAmountMaximum, setValue])

  const impairFully = useCallback(() => {
    setValue(FieldName, impairmentAmountMaximum, {
      shouldValidate: true,
    })
  }, [setValue, impairmentAmountMaximum])

  return (
    <>
      <InputNumber
        name={FieldName}
        className={AntInputAlignRight}
        formatter={value => `${yenCheckNull(value)}`}
        controls={false}
        isShowError={false}
        disabled={!canEdit}
      />
      <LinkLabel className={SmallLabelClass} onClick={impairFully} disabled={!canEdit}>
        {t('impair_entire_book_value')}
      </LinkLabel>
      <ErrorMessage name={FieldName} errors={null} />
    </>
  )
}
